module.exports = __webpack_public_path__ + "static/media/img_jardin_privado.2eb039d5.png";